/**
 * @generated SignedSource<<7a9b22747ccfff7767914e6788fec119>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type OrgFeatures = "ANALYTICS" | "FILES" | "MAP" | "PRODUCTS" | "ROUTINES" | "SIGNALS" | "SPACES" | "TODOS";
import { FragmentRefs } from "relay-runtime";
export type OrgHomeMasterComponent_query$data = {
  readonly me: {
    readonly email: string;
    readonly " $fragmentSpreads": FragmentRefs<"OrgLogoutButton_me">;
  } | null;
  readonly organisation: {
    readonly features: ReadonlyArray<OrgFeatures>;
    readonly hasAdminAccess: boolean;
    readonly logo: {
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"Image_image">;
    } | null;
    readonly name: string;
  };
  readonly viewer: {
    readonly workspaces: ReadonlyArray<{
      readonly id: string;
      readonly timezone: string;
      readonly " $fragmentSpreads": FragmentRefs<"WorkspaceBreadcrumbs_workspaces" | "WorkspaceSelector_workspaces">;
    }> | null;
  } | null;
  readonly " $fragmentType": "OrgHomeMasterComponent_query";
};
export type OrgHomeMasterComponent_query$key = {
  readonly " $data"?: OrgHomeMasterComponent_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"OrgHomeMasterComponent_query">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "OrgHomeMasterComponent_query",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "alias": null,
        "args": null,
        "concreteType": "Organisation",
        "kind": "LinkedField",
        "name": "organisation",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Image",
            "kind": "LinkedField",
            "name": "logo",
            "plural": false,
            "selections": [
              (v0/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "Image_image"
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "features",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hasAdminAccess",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      "action": "THROW"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Viewer",
      "kind": "LinkedField",
      "name": "viewer",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Workspace",
          "kind": "LinkedField",
          "name": "workspaces",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "timezone",
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "WorkspaceSelector_workspaces"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "WorkspaceBreadcrumbs_workspaces"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "me",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "email",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "OrgLogoutButton_me"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};
})();

(node as any).hash = "cacb5f57967486b0f08af15bed56f55c";

export default node;
